import { WarningIcon } from './mailNotifyIcons';
import { openSettings } from '../utils/settingsModal';
import './MailNotifyCard.css';

/**
 * 信件即時通知新架構的紅色錯誤條（C06、C09、C12 共用）。
 *
 * Outlook 授權失效（403 OUTLOOK_REAUTH_REQUIRED）時，電腦版在同一條上附「前往設定」：
 * 這時上方的 Outlook 卡可能因為連結狀態仍是 active 而沒出現，不給入口使用者就不知道去哪裡修。
 * 手機版不能連結 Outlook，不給入口。
 *
 * @param {{ error: null|string|{message: string, errorCode?: string}, isMobile?: boolean }} props
 */
export default function MailNotifyErrorNotice({ error, isMobile = false }) {
  if (!error) return null;
  const message = typeof error === 'string' ? error : error.message;
  const needsOutlook = typeof error === 'object' && error.errorCode === 'OUTLOOK_REAUTH_REQUIRED';
  return (
    <div className="mail-alert-task__notice mail-alert-task__notice--error" role="alert">
      <WarningIcon />
      <span className="mail-alert-task__notice-text">{message}</span>
      {needsOutlook && !isMobile && (
        <button type="button" className="mail-alert-task__notice-link" onClick={() => openSettings('connector')}>
          前往設定
        </button>
      )}
    </div>
  );
}
